import React from "react";
import { useDelete, usePost } from "../../api/useCall";
import { useMutateBody } from "../../api/useQuery";

function useToggleFavoriteProject() {
  const addProjectToFavourites = usePost("/users/favorites/projects/:projectId(uuid)");
  const removeProjectFromFavourites = useDelete("/users/favorites/projects/:projectId(uuid)");
  const mutateFavoriteProjects = useMutateBody("/users/favorites/projects", {});

  const toggle = React.useCallback(
    async (projectId: string, isFavorite: boolean) => {
      const rollback = mutateFavoriteProjects(projectIds =>
        isFavorite ? projectIds.filter(id => id !== projectId) : [...projectIds, projectId],
      );

      try {
        if (isFavorite) {
          await removeProjectFromFavourites({ routeParams: { projectId } });
        } else {
          await addProjectToFavourites({ routeParams: { projectId } });
        }

        return true;
      } catch (error) {
        rollback();
        throw error;
      }
    },
    [addProjectToFavourites, mutateFavoriteProjects, removeProjectFromFavourites],
  );

  return toggle;
}

export default useToggleFavoriteProject;
